import React__default from "react";
import clsx from "clsx";
import { Icon } from "../../icon/icon/icon.mjs";
import { SkeletonItem } from "../../skeleton/skeleton-item/skeleton-item.mjs";
const CheckIndicator = ({ checked, invalid, disabled, size, employee, skeleton, onClick, className }) => {
  const classNames = clsx(
    "check-indicator",
    "check-indicator--".concat(size),
    {
      "check-indicator--employee": !!employee,
      "is-checked": checked,
      "is-invalid": invalid,
      "is-disabled": disabled
    },
    className
  );
  if (skeleton) {
    return /* @__PURE__ */ React__default.createElement(SkeletonItem, { className: classNames });
  }
  return /* @__PURE__ */ React__default.createElement("span", { className: classNames, onClick }, /* @__PURE__ */ React__default.createElement(Icon, { modifiers: "#check", className: "check-indicator__icon" }));
};
export {
  CheckIndicator
};
